<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false">
    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronDownIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>
